import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { Dynamic } from '../../shared/model/dynamicfiled.model';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { CustomfieldDynamicModalComponent } from '../customfield-dynamic-modal/customfield-dynamic-modal.component';

@Component({
    selector: 'app-list-customfield-dynamic',
    templateUrl: './list-customfield-dynamic.component.html',
    styleUrls: ['../documents.component.scss'],
    standalone: false
})
export class ListCustomfieldDynamicComponent implements OnInit {
  title: string
  arrayTypesField = []
  selectedTypesDynamic:Dynamic
  dynamicfield: Array <any>
  statusModal = false
  emptyButton: string
  showMessage: boolean = false
  showMessageArray: boolean = false

  @Output() passEntry: EventEmitter<any> = new EventEmitter();


  constructor(
    public modalService: NgbModal,
    public activeModal: NgbActiveModal,
  ) { }
  ngOnInit() {
    this.validateStatusArray()
  }

aceppt(){
  this.activeModal.close(this.dynamicfield)
}
confirm(typeListSubject) {
  const data = { ok:true, all: typeListSubject}
  this.passEntry.emit(data);


}
createCustomfields(){
  const subjectModal = this.modalService.open(CustomfieldDynamicModalComponent, {size: 'lg'})
  subjectModal.componentInstance.title = 'Crea un nuevo campo.'

  subjectModal.result.then(value => {

    if(typeof this.dynamicfield == 'undefined'){
      this.dynamicfield = []
    }
    this.dynamicfield.push(value)

  })
}

removeNewCustomField(i){
  this.dynamicfield = this.dynamicfield.filter( function( e ) {
    return e !== i;
  } );
  if(this.dynamicfield.length < 0){
    this.statusMesage()
  }
}
validateStatusArray(){
  if(typeof this.dynamicfield == 'undefined'){
    this.statusMesage()
  }
}
statusMesage(){
  this.showMessageArray = true
  setTimeout(
    () => this.showMessageArray = false,
  4000)
}
copy(item){
  const selBox = document.createElement('textarea')
  selBox.style.position = 'fixed'
  selBox.style.left = '0'
  selBox.style.top = '0'
  selBox.style.opacity = '0'
  selBox.value = `{#${item.name}#}`
  document.body.appendChild(selBox)
  selBox.focus()
  selBox.select()
  document.execCommand('copy')
  document.body.removeChild(selBox)
  this.showMessage = true
    setTimeout(
      () => this.showMessage = false,
    5000)
}

}
